import { JourneyType } from '@/types/enum'

const { STANDARD, ROUND, SHUTTLE, EMPTY } = JourneyType

const makeRoundRows = (journey) => {
  const rows = []
  const default_row = {}

  return []
}

const makeShuttleRow = (journey) => {}

const parseJourneys = (journeys) => {
  return journeys.map((j) => {
    const row = {}

    row.a = j.day
    if (j.type === ROUND) {
      //
    }
    if (j.type === SHUTTLE) {
      row.b = j.origin.full_name
      row.c = j.destination.full_name
      // d
      // e
      // f
      // g
      // h
      // i
      // l
      // m
      row.n = j.distance_loaded
      row.o = j.distance_empty
      // p
      // q
      row.r = j.journeys_count
    }

    return {
      id: j.id,
      date: j.day,
      type: j.type,
      type2: j.type2,
      is_ended: j.is_ended,
      _meta: j._meta,
      rows: row,
    }
  })
}

export const toDocument = (survey) => {
  const journeys = parseJourneys(survey.journeys)

  return {
    header: '',
    standards: [],
    rounds_and_shuttles: [],
    journeys,
  }
}
